import React from 'react';
import { useHelp } from '../../../context/HelpContext';
import '../../../assets/scss/views/Help.scss';

const ViewBackendIndexJs = () => {
  const { ui: { currentFile } } = useHelp();

  return (
    <div className="help-documentation-view">
      <div className="help-documentation-header">
        <h1>index.js - Archivo Principal de Ejecución</h1>
        <p className="help-documentation-subtitle">
          Archivo principal que inicializa y ejecuta el servidor Node.js
        </p>
      </div>

      <div className="help-documentation-content">
        <section className="help-documentation-section">
          <h2>Descripción General</h2>
          <p>
            El archivo <code>index.js</code> es el punto de entrada principal del servidor backend. 
            Se encarga de inicializar todos los servicios necesarios, configurar las tareas programadas 
            y mantener el servidor en ejecución.
          </p>
        </section>

        <section className="help-documentation-section">
          <h2>Funcionalidades Principales</h2>
          <ul>
            <li><strong>Inicialización del servidor:</strong> Configura y arranca el servidor HTTP</li>
            <li><strong>Gestión de WhatsApp:</strong> Inicializa y mantiene la conexión con WhatsApp</li>
            <li><strong>Sistema de logging:</strong> Configura el sistema de logs vehiculares</li>
            <li><strong>Tareas programadas:</strong> Ejecuta verificaciones automáticas de documentos y botiquines</li>
            <li><strong>Monitoreo de desplazamientos:</strong> Verifica desplazamientos laborales diariamente</li>
            <li><strong>Manejo de errores:</strong> Captura y maneja errores no controlados</li>
          </ul>
        </section>

        <section className="help-documentation-section">
          <h2>Servicios Inicializados</h2>
          <div className="help-documentation-code-block">
            <h3>Servicios Principales</h3>
            <ul>
              <li><code>WhatsAppClientManager</code> - Gestión de conexiones WhatsApp</li>
              <li><code>VehicleLoggingService</code> - Sistema de logs vehiculares</li>
              <li><code>DocumentNotificationService</code> - Notificaciones de documentos</li>
              <li><code>FirstAidKitExpirationService</code> - Verificación de botiquines</li>
              <li><code>TravelDisplacementMonitorService</code> - Monitoreo de desplazamientos</li>
            </ul>
          </div>
        </section>

        <section className="help-documentation-section">
          <h2>Tareas Programadas (Cron Jobs)</h2>
          <div className="help-documentation-code-block">
            <h3>Verificación de Documentos y Botiquines</h3>
            <p><strong>Programación:</strong> Cada 2 días a las 3:00 AM</p>
            <ul>
              <li>Verifica documentos próximos a vencer</li>
              <li>Comprueba botiquines de primeros auxilios</li>
              <li>Envía notificaciones por email</li>
            </ul>

            <h3>Monitoreo de Desplazamientos</h3>
            <p><strong>Programación:</strong> Diariamente a las 9:00 AM</p>
            <ul>
              <li>Verifica desplazamientos laborales</li>
              <li>Registra logs en el sistema</li>
              <li>Envía alertas si es necesario</li>
            </ul>
          </div>
        </section>

        <section className="help-documentation-section">
          <h2>Manejo de Errores</h2>
          <div className="help-documentation-code-block">
            <h3>Errores No Controlados</h3>
            <ul>
              <li>Captura excepciones no manejadas</li>
              <li>Envía notificaciones de error por email</li>
              <li>Registra logs detallados</li>
            </ul>

            <h3>Timeouts de Conexión</h3>
            <ul>
              <li>WhatsApp: 60 segundos</li>
              <li>Logging: 10 segundos</li>
              <li>Reintentos automáticos configurados</li>
            </ul>
          </div>
        </section>

        <section className="help-documentation-section">
          <h2>Variables de Entorno</h2>
          <div className="help-documentation-code-block">
            <h3>Configuración Importante</h3>
            <ul>
              <li><code>DETECT_LOCAL</code> - Detecta entorno local</li>
              <li><code>NODE_DEBUG</code> - Controla logs de debug</li>
              <li><code>DEBUG</code> - Configuración de debug</li>
              <li><code>REDIS_ENABLED</code> - Habilita/deshabilita Redis</li>
            </ul>
          </div>
        </section>

        <section className="help-documentation-section">
          <h2>Dependencias Principales</h2>
          <div className="help-documentation-code-block">
            <ul>
              <li><code>node-cron</code> - Tareas programadas</li>
              <li><code>socket.io</code> - Comunicación en tiempo real</li>
              <li><code>express</code> - Framework web</li>
              <li><code>dotenv</code> - Variables de entorno</li>
            </ul>
          </div>
        </section>

        <section className="help-documentation-section">
          <h2>Archivos Relacionados</h2>
          <div className="help-documentation-related-files">
            <ul>
              <li><strong>whatsappManager.js</strong> - Gestión de WhatsApp y WebSocket</li>
              <li><strong>app.js</strong> - Configuración de Express</li>
              <li><strong>sessionManager.js</strong> - Gestión de sesiones</li>
              <li><strong>config/config.js</strong> - Configuración general</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ViewBackendIndexJs; 